import { render, staticRenderFns } from "./host-common-down.vue?vue&type=template&id=2b2fb62c&scoped=true&"
import script from "./host-common-down.vue?vue&type=script&lang=js&"
export * from "./host-common-down.vue?vue&type=script&lang=js&"
import style0 from "./host-common-down.vue?vue&type=style&index=0&id=2b2fb62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2fb62c",
  null
  
)

export default component.exports